import { Nullable } from "../../Types/Common";
import { IAdditionalManagerUserList } from "../../Types/DailyReport";
import { RootState } from "../Store";

export const selectUserList = (
  state: RootState
): Nullable<IAdditionalManagerUserList[]> => {
  if (!state.employeesList) return null;
  const userListDetails =
    state &&
    state.employeesList &&
    state.employeesList.data &&
    state.employeesList.data?.data.length > 0
      ? state.employeesList.data.data
      : [];
  return userListDetails && userListDetails;
};

export const selectEmployeesList = (state: RootState) =>
  state.employeesList.data;

export const selectEmployeesListError = (state: RootState) =>
  state.employeesList.error;

export const selectEmployeeListLoading = (state: RootState) =>
  state.employeesList.loading;
